
import {
  Component, Watch, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import UpdateButton from '@/components/UpdateButton.vue';
import TextFieldWithConfirm from '@/components/TextFieldWithConfirm.vue';
import SlotWithConfirm from '@/components/SlotWithConfirm.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import Editor from '@/components/Editor.vue';
import { BoxStatusType } from '@/types';
import TaskActivityBox from '@/components/TaskActivityBox.vue';
import {
  getLeadCustomValueText,
  getLeadCustomValueBoolean,
  getLeadCustomValueDate,
} from '@/helpers';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';

moment.locale('it');

const isBlank = (str) => (!str || /^\s*$/.test(str));

@Component({
  components: {
    SwitchWithConfirm,
    AttachmentWithStatus,
    AttachmentsList,
    UpdateButton,
    TextFieldWithConfirm,
    SlotWithConfirm,
    DatePickerDialog,
    Editor,
    TaskActivityBox,
  },
})
export default class EditMUP1Dialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  powerIncreased: string | null | undefined = null
  powerIncreasedDate: Date | null = null

  ibanConnessione: string | null | undefined = null

  pod: string | null | undefined = null
  podConfirmed = false

  installationEmail: string | null | undefined = null
  installationPhone1: string | null | undefined = null
  emailConfirmed = false
  phone1Confirmed = false

  // installationAddress
  installationToponym: string | null | undefined = null
  installationStreet: string | null | undefined = null
  installationHouseNumber: string | null | undefined = null
  installationPostalCode: string | null | undefined = null
  installationLocation: string | null | undefined = null
  installationProvince: string | null | undefined = null
  installationAddressConfirmed = false

  // residentialAddress
  hasInstallationResidence = false
  installationResidenceToponym: string | null | undefined = null
  installationResidenceStreet: string | null | undefined = null
  installationResidenceHouseNumber: string | null | undefined = null
  installationResidencePostalCode: string | null | undefined = null
  installationResidenceLocation: string | null | undefined = null
  installationResidenceProvince: string | null | undefined = null
  residentialAddressConfirmed = false

  visuraCatastale: BoxStatusType = 'todo'
  ultimaBollettaElettrica: BoxStatusType = 'todo'
  documentiIdentita: BoxStatusType = 'todo'
  unifilare: BoxStatusType = 'todo'

  practiceNotes: string | null = null

  // GSE
  checkAccountGSE: BoxStatusType = 'todo'
  checkAccountGSELastUpdate: Date | null = null
  checkAccountGSEUpdater: string | null = null
  usernameGSE: string | null = null
  passwordGSE: string | null = null
  checkAccountGSENotes: string | null = null

  checkContoEnergia: string | null = null
  checkContoEnergiaValues = [
    {
      text: 'Da fare',
      value: 'todo',
    },
    {
      text: '1° conto',
      value: 'conto1',
    },
    {
      text: '2° conto',
      value: 'conto2',
    },
    {
      text: '3° conto',
      value: 'conto3',
    },
    {
      text: '4° conto',
      value: 'conto4',
    },
    {
      text: '5° conto',
      value: 'conto5',
    },
    {
      text: 'NO',
      value: 'no',
    },
  ]

  // Questo componente necessita che la Lead a cui è associato l'allegato sia selezionata

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Imposta i parametri relativi all'aumento di potenza
    this.powerIncreased = getLeadCustomValueText(this.lead, 'powerIncreased') ?? null;
    this.powerIncreasedDate = getLeadCustomValueDate(this.lead, 'powerIncreasedDate') ?? null;

    this.ibanConnessione = getLeadCustomValueText(this.lead, 'ibanConnessione') ?? null;

    this.pod = getLeadCustomValueText(this.lead, 'pod') ?? null;
    this.podConfirmed = getLeadCustomValueBoolean(this.lead, 'podConfirmed') ?? false;

    this.emailConfirmed = getLeadCustomValueBoolean(this.lead, 'emailConfirmed') ?? false;
    this.phone1Confirmed = getLeadCustomValueBoolean(this.lead, 'phone1Confirmed') ?? false;

    this.checkAccountGSE = getLeadCustomValueText(this.lead, 'checkAccountGSE') as BoxStatusType ?? 'todo';
    this.checkAccountGSELastUpdate = getLeadCustomValueDate(this.lead, 'checkAccountGSELastUpdate') ?? null;
    this.checkAccountGSEUpdater = getLeadCustomValueText(this.lead, 'checkAccountGSEUpdater') ?? '';
    this.usernameGSE = getLeadCustomValueText(this.lead, 'usernameGSE') ?? '';
    this.passwordGSE = getLeadCustomValueText(this.lead, 'passwordGSE') ?? '';
    this.checkContoEnergia = getLeadCustomValueText(this.lead, 'checkContoEnergia') ?? '';
    this.checkAccountGSENotes = getLeadCustomValueText(this.lead, 'checkAccountGSENotes') ?? '';

    // Se non sono presenti dati della bolletta, recupera i dati del contatto
    if (this.lead?.hasInstallation !== true) {
      this.installationToponym = this.lead?.toponimo ?? 'via';
      this.installationStreet = this.lead?.indirizzo ?? null;
      this.installationHouseNumber = this.lead?.civico ?? null;
      this.installationPostalCode = this.lead?.cap ?? null;
      this.installationLocation = this.lead?.citta ?? null;
      this.installationProvince = this.lead?.provincia ?? null;
      this.installationEmail = this.lead?.email ?? null;
      this.installationPhone1 = this.lead?.telefono ?? null;
    } else {
      this.installationToponym = getLeadCustomValueText(this.lead, 'installationToponym') ?? 'via';
      this.installationStreet = getLeadCustomValueText(this.lead, 'installationStreet') ?? null;
      this.installationHouseNumber = getLeadCustomValueText(this.lead, 'installationHouseNumber') ?? null;
      this.installationPostalCode = getLeadCustomValueText(this.lead, 'installationPostalCode') ?? null;
      this.installationLocation = this.lead?.installationLocation ?? null;
      this.installationProvince = this.lead?.installationProvince ?? null;
      this.installationEmail = getLeadCustomValueText(this.lead, 'installationEmail') ?? null;
      this.installationPhone1 = getLeadCustomValueText(this.lead, 'installationPhone1') ?? null;
    }

    this.installationAddressConfirmed = getLeadCustomValueBoolean(this.lead, 'installationAddressConfirmed') ?? false;

    // residentialAddress
    this.hasInstallationResidence = getLeadCustomValueBoolean(this.lead, 'hasInstallationResidence') ?? false;
    this.installationResidenceToponym = getLeadCustomValueText(this.lead, 'installationResidenceToponym') ?? 'via';
    this.installationResidenceStreet = getLeadCustomValueText(this.lead, 'installationResidenceStreet') ?? null;
    this.installationResidenceHouseNumber = getLeadCustomValueText(this.lead, 'installationResidenceHouseNumber') ?? null;
    this.installationResidencePostalCode = getLeadCustomValueText(this.lead, 'installationResidencePostalCode') ?? null;
    this.installationResidenceLocation = getLeadCustomValueText(this.lead, 'installationResidenceLocation') ?? null;
    this.installationResidenceProvince = getLeadCustomValueText(this.lead, 'installationResidenceProvince') ?? null;
    this.residentialAddressConfirmed = getLeadCustomValueBoolean(this.lead, 'residentialAddressConfirmed') ?? false;

    // Ottiene lo stato degli allegati dalla Lead associata
    this.visuraCatastale = (getLeadCustomValueText(this.lead, 'visuraCatastale') ?? 'todo') as BoxStatusType;
    this.ultimaBollettaElettrica = (getLeadCustomValueText(this.lead, 'ultimaBollettaElettrica') ?? 'todo') as BoxStatusType;
    this.documentiIdentita = (getLeadCustomValueText(this.lead, 'documentiIdentita') ?? 'todo') as BoxStatusType;
    this.unifilare = (getLeadCustomValueText(this.lead, 'unifilare') ?? 'todo') as BoxStatusType;

    // Note alle pratiche
    this.practiceNotes = getLeadCustomValueText(this.lead, 'practiceNotes') ?? null;

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  get powerIncreasedDateRequiredRules() {
    return this.powerIncreased === 'yes' && !!this.powerIncreasedDate;
  }

  get isInstallationAddressValid(): boolean {
    return !isBlank(this.installationToponym)
      && !isBlank(this.installationStreet)
      && !isBlank(this.installationHouseNumber)
      && !isBlank(this.installationPostalCode)
      && !isBlank(this.installationLocation)
      && !isBlank(this.installationProvince);
  }

  @Watch('isInstallationAddressValid')
  onIsInstallationAddressValidChange(val: boolean) {
    console.log(`${this.constructor.name}: onIsInstallationAddressValidChange(${val})`); // eslint-disable-line no-console
    if (val !== true) this.onFieldUpdated('installationAddressConfirmed', false);
  }

  get isResidentialAddressValid(): boolean {
    if (!this.hasInstallationResidence && this.isInstallationAddressValid) return true;

    return !isBlank(this.installationResidenceToponym)
      && !isBlank(this.installationResidenceStreet)
      && !isBlank(this.installationResidenceHouseNumber)
      && !isBlank(this.installationResidencePostalCode)
      && !isBlank(this.installationResidenceLocation)
      && !isBlank(this.installationResidenceProvince);
  }

  get checkAccountGSETooltip(): string | null | undefined {
    return this.checkAccountGSELastUpdate
      ? `Ultima modifica: ${moment(this.checkAccountGSELastUpdate).format('L')} ore ${moment(this.checkAccountGSELastUpdate).format('LT')} (${this.checkAccountGSEUpdater})`
      : 'Nessuna modifica effettuata';
  }

  get checkAccountGSEClass(): string | null | undefined {
    return this.checkAccountGSE === 'na' ? 'mb-5' : null;
  }

  @Watch('isResidentialAddressValid')
  onIsResidentialAddressValidChange(val: boolean) {
    console.log(`${this.constructor.name}: onIsResidentialAddressValidChange(${val})`); // eslint-disable-line no-console
    if (val !== true) this.onFieldUpdated('residentialAddressConfirmed', false);
  }

  podAlert(pod: string | null | undefined) {
    // ritorna true se il codice POD inizia con la stringa it002e
    return pod !== null ? pod?.replace(/ /g, '').toLowerCase().startsWith('it002e') || false : false;
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Modifico eventuali campi collegati
    const update = {} as { [key: string]: unknown };
    switch (field) {
      case 'powerIncreased':
        if (this.powerIncreased === 'yes') {
          this.powerIncreasedDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.powerIncreasedDate = this.powerIncreasedDate;
        } else {
          this.powerIncreasedDate = null;
          update.powerIncreasedDate = null;
        }
        break;

      case 'checkAccountGSE':
        this.checkAccountGSELastUpdate = new Date();
        update.checkAccountGSELastUpdate = this.checkAccountGSELastUpdate;
        this.checkAccountGSEUpdater = this.$store.getters.currentUser.name;
        update.checkAccountGSEUpdater = this.checkAccountGSEUpdater;
        break;

      default:
        break;
    }
    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    // Richiama il metodo del mixin
    return this.mixinOnFieldUpdated(field, value);
  }
}
